import { render, staticRenderFns } from "./PagosParciales.vue?vue&type=template&id=791a6fc0&"
import script from "./PagosParciales.vue?vue&type=script&lang=js&"
export * from "./PagosParciales.vue?vue&type=script&lang=js&"
import style0 from "./PagosParciales.vue?vue&type=style&index=0&id=791a6fc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports